import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import ContactComponent, { ContactComponentProps } from 'src/modules/contact/Contact.component';
import ContactForm from 'src/value-objects/ContactForm';
import { sendContactForm, SendContactFormAction } from 'src/actions/contact-form/send/SendContactForm.actions';

interface DispatchProps {
  sendContactForm: (contactForm: ContactForm) => Promise<SendContactFormAction>;
}

interface State {
    name: string;
    surname: string;
    email: string;
    phone: string;
    message: string;
    checkboxTerms: boolean;
    success: boolean;
    error: boolean;
    errorMessage: Object;
}

interface Props extends DispatchProps {
}

class ContactContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      name: '',
      surname: '',
      email: '',
      phone: '',
      message: '',
      checkboxTerms: false,
      success: false,
      error: false,
      errorMessage: {}
    };
  }

  public render(): React.ReactNode {
    return (
      <ContactComponent{...this.getComponentProps()} />
    );
  }

  private getComponentProps(): ContactComponentProps {
    return {
      name: this.state.name,
      surname: this.state.surname,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
      checkboxTerms: this.state.checkboxTerms,
      success: this.state.success,
      error: this.state.error,
      errorMessage: this.state.errorMessage,
      handleChange: (key: string) => this.handleChange(key),
      sendForm: () => this.sendForm(),
      handleChangeCheckbox: () => this.handleChangeCheckbox()
    };
  }

  private sendForm(): void {
    let err: boolean = false;
    if (this.state.name === '') {
      this.setState( {
        error: true,
        errorMessage: {
          name: ['error en nombre']
        }
      });
      err = true;
    }
    if (this.state.surname === '') {
      this.setState( {
        error: true,
        errorMessage: {
          surname: ['error en apellido/s']
        }
      });
      err = true;
    }
    if (this.state.email === '') {
      this.setState( {
        error: true,
        errorMessage: {
          email: ['error en email']
        }
      });
      err = true;
    }
    if (this.state.message === '') {
      this.setState( {
        error: true,
        errorMessage: {
          message: ['error en message']
        }
      });
      err = true;
    }
    if (!this.state.checkboxTerms) {
      this.setState( {
        error: true,
        errorMessage: {
          checkTerms: ['error en terminos legales']
        }
      });
      err = true;
    }
    if (!err) {
      const contactForm: ContactForm = new ContactForm(this.state);
      this.props.sendContactForm(contactForm);
      this.setState({
        success: true
      });
    }
  }

  private handleChangeCheckbox(): void {
    this.setState({checkboxTerms: !this.state.checkboxTerms});
  }

  private handleChange(key: string): (value: string | File | boolean) => void {
    return (
      (value: string | boolean) => {
        this.setState({
            ...this.state,
            [key]: value
          });
      }
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    sendContactForm: (contactForm: ContactForm): Promise<SendContactFormAction> => (
      dispatch(sendContactForm(contactForm))
    )
  };
};

export default connect(null, mapDispatchToProps)(ContactContainer);


// WEBPACK FOOTER //
// ./src/modules/contact/Contact.container.tsx